/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Product Card Tariff Field component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.10.0
 */

import { FC } from 'react';

import { icons } from '../../../../../assets';
import { FlexStyled } from '../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../components/common/Block/Img';
import ArrowTooltip from '../../../../../components/common/Tooltip/Tooltip';
import { ProductCardTariffFieldStyled, ProductCardTariffFieldTitleStyled } from '../styled/ProductCardTariffStyled';

export interface IProductCardTariffFieldProps {
    title: string;
    tooltip?: string;
}

const ProductCardTariffField: FC<IProductCardTariffFieldProps> = props => (
    <ProductCardTariffFieldStyled>
        <FlexStyled justifyContent="space-between">
            <ProductCardTariffFieldTitleStyled>{ props.title }</ProductCardTariffFieldTitleStyled>
            {
                props.tooltip && <ArrowTooltip message={props.tooltip} placement="top-start">
                    <ImgStyled className="small" src={icons.infoBlueIcon} />
                </ArrowTooltip>
            }
        </FlexStyled>
        { props.children }
    </ProductCardTariffFieldStyled>
);

export default ProductCardTariffField;
